// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","865":"component---src-pages-ingredients-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"24d224b93e4c485b2ca3","731":"3e6d8c1ed7e393826b5e","843":"b60d6e54561e1660cafc","865":"926e64cede5c7482451d","883":"e966e78e20ee7f930ee1"}[chunkId] + ".js";
};